import { render, staticRenderFns } from "./ImageViewerMiniComponent.vue?vue&type=template&id=5457765f&scoped=true&"
import script from "./ImageViewerMiniComponent.vue?vue&type=script&lang=js&"
export * from "./ImageViewerMiniComponent.vue?vue&type=script&lang=js&"
import style0 from "./ImageViewerMiniComponent.vue?vue&type=style&index=0&id=5457765f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5457765f",
  null
  
)

export default component.exports